import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../_App/Redux/hooks";

import AssuranceForm from "../Components/Assurances/AssuranceForm";
import { findAssurances } from "../_App/Redux/Slices/assurances/assurancesSlice";
import AssurancesList from "../Components/Assurances/ListAssurances";
import { findVehicules } from "../_App/Redux/Slices/vehicules/vehiculesSlice";
import {
  Auth,
  currentSousSociete,
  OnlineUser,
} from "../_App/Redux/Slices/auth/authSlice";
import { findFiles } from "../_App/Redux/Slices/files/filesSlice";

const Assurances = () => {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedAssurance, setSelectedAssurance] = useState(undefined);
  const currentSousSte = useAppSelector(currentSousSociete);
  const [load, setLoad] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Add state for search term

  useEffect(() => {
    if (currentSousSte) {
      dispatch(findAssurances(currentSousSte));
      dispatch(findVehicules(currentSousSte));
      dispatch(findFiles(null))
    }
  }, [dispatch, load, currentSousSte]);

  return (
    <div>
      <nav className="navbar search-bar">
        <a href="#" className="sidebar-toggler">
          <i data-feather="menu" />
        </a>
        <div className="navbar-content">
          <form className="search-form">
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <i data-feather="search" />
                </div>
              </div>
              <input
                type="text"
                className="form-control"
                id="navbarForm"
                placeholder="Chercher ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
              />
            </div>
          </form>
        </div>
      </nav>
      <nav className="page-breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#">Assurances</a>
          </li>
        </ol>
      </nav>
      <div className="row content-card">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <i className="mdi mdi-tune-vertical text-primary " /> Liste des
              Assurances{" "}
              <button
                className="btn btn-primary float-right"
                onClick={() => setShowModal(true)}
              >
                +
              </button>
            </div>
            <AssurancesList
              searchTerm={searchTerm} // Pass search term as a prop
              selectedAssurance={selectedAssurance}
              setSelectedAssurance={setSelectedAssurance}
              setShowModal={setShowModal}
              load={load}
              setLoad={setLoad}
            />
            <AssuranceForm
              showModal={showModal}
              setShowModal={setShowModal}
              selectedAssurance={selectedAssurance}
              setSelectedAssurance={setSelectedAssurance}
              load={load}
              setLoad={setLoad}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assurances;
